// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hn","advertCardNum":"c-a_ho"};